import { AuthGuardService } from '../services/auth-guard.service';
import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';

const SupportRouting: Routes = [
    // login view
    {

        path: 'dashboard', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: DashboardComponent },
            { path: 'dashboard1', component: DashboardComponent },

            // handle all other routes
            { path: '**', component: DashboardComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(SupportRouting)],
    exports: [RouterModule]
})
export class DashboardRoutingModule { }
